import { OrganizationSuggestItem } from '@shared/model/organization';
import { useEffect, useRef } from 'react';

export const useSaveSuggestions = (suggestions: OrganizationSuggestItem[]) => {
    const uniqSuggestions = useRef<Record<string, OrganizationSuggestItem>>({});
    useEffect(() => {
        suggestions.forEach((suggestion) => {
            const inn = suggestion.inn;
            uniqSuggestions.current[inn] = suggestion;
        });
    }, [suggestions]);
    return Object.values(uniqSuggestions.current);
};
